import { Css } from "@homebound/beam";
import { ReactPortal } from "react";
import { createPortal } from "react-dom";
import { useStepperContext } from "src/components/stepper/StepperContext";

// Helper component to enable appending content the <StepperProvider /> via a portal
export function StepActions(props: { children: JSX.Element }): ReactPortal | JSX.Element {
  const { stepActionsEl } = useStepperContext();
  const { children } = props;
  const wrappedChildren = <div css={Css.df.aic.gap2.$}>{children}</div>;

  // a fallback for tests should stepperActionsEl not exist so tests can find the elements it needs
  if (!stepActionsEl) {
    return wrappedChildren;
  }

  return createPortal(wrappedChildren, stepActionsEl);
}
